import { FlexiblePage } from "@/components/FlexiblePage";

const SLUGS = ["solutions"];
const PRERENDER_ID = "__PR_SOLUTIONS__";
const FALLBACK_TITLE = "Solutions tailored to your currency operations | OnPlexus";

type SolutionsProps = {
  lang?: string;
};

export default function Solutions({ lang }: SolutionsProps = {}) {
  return (
    <FlexiblePage
      slugs={SLUGS}
      prerenderId={PRERENDER_ID}
      fallbackTitle={FALLBACK_TITLE}
      loadingLabel="Loading solutions…"
      lang={lang}
    />
  );
}
